import { ProductLine } from './product-line';
import { Model } from './model';
import { Customer } from './customer';
import { SelectedOption } from './selected-option';
import { Quote } from './quote';
import { Option } from './option';

export class MchApplicationState {
    public customer: Customer;
    public productLine: ProductLine;
    public model: Model;
    public quote: Quote;
    public userId: number;
    public userName: string;
    public categoryId: number;
    public modelId: number;
    public productLineId: number;
    public quoteId: number;
    public customerId: number;
    public retailerNumber: string;
    public plantId: number;
    public pricingView: number;
    public optionsList: Option[];
    public selectedOptions: SelectedOption[];
    public firstName: string;
    public lastName: string;
    public prospectId: number;

    constructor() {
        this.selectedOptions = new Array<SelectedOption>();
        this.optionsList = new Array<Option>();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/application-state.ts